/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const kMiniprogramSharingThumbnailImageUrl =
  'https://img.zhichetech.com/assets/img/miniprogram-sharing-thumbnail.png';

export const AnimationSource = {
  checkmark: require('./lottiefiles/check-mark.json'),
  confettiDay: require('./lottiefiles/confetti-day.json'),
  congratulation: require('./lottiefiles/congratulation-success-batch.json'),
  horray: require('./lottiefiles/horray-animation.json'),
  success: require('./lottiefiles/success-animation'),
  loadingCircles: require('./lottiefiles/loading-circles.json'),
  loadingText: require('./lottiefiles/loading-characters.json'),
  loadingCircle: require('./lottiefiles/loading-circle.json'),
  confetti: require('./lottiefiles/confetti.json'),
};

// https://business.facebook.com/creatorstudio/fm_sound_collection?collection_id=free_form_collection&sound_collection_tab=sound_effects
export const SoundFile = {
  chirp: require('./sound/chirp.mp3'),
  ding: require('./sound/ding.mp3'),
  sent: require('./sound/sent.mp3'),
  dartPull: require('./sound/dart-pull.wav'),
  laserBird01: require('./sound/laser-bird-01.wav'),
  laserBubble: require('./sound/laser-bubble.wav'),
  liquidDrip01: require('./sound/liquid-drip-01.m4a'),
  message01: require('./sound/message-01.wav'),
  qrcodeFound: require('./sound/qrcode_found.wav'),
  qrcodeCompleted: require('./sound/qrcode_completed.mp3'),
  dingMetallic: require('./sound/ding-metallic.wav'),
};

export const kDefaultVehicleImage = require('@euler/assets/img/default-car-img.png');
export const kDefaultIntroVideo = require('@euler/assets/videos/default-intro-video.mp4');
export const kBlackOverlayImage = require('@euler/assets/img/black-overlay.png');
